$(document).ready(function() {
  var pageHeader = $(".js-header");

  $(".js-user-subscribe-toggle-promo").on("change", function() {
    pageHeader.toggleClass("dc-promo-sept2019__subscribe");

    // Contained this so that it doesn't break the pricing JS
    (function() {
      var elPromoAmount = $(".dc-promo-sept2019__subscribe");
      var currencyCode = Cookies.get("dc_pricing_currency");
      console.log(currencyCode);

      if (currencyCode) {
        elPromoAmount.addClass("currency--inr");
      } else {
        elPromoAmount.addClass("currency--inr");
      }
    })();
  });
});
